import React from 'react';
export interface BuildInfo {
  appId: string;
  sourceCommit: string;
  buildId: string;
  builtAt: string;
  channel: 'development' | 'release';
  environment: string;
  dirty: boolean;
}
declare const __BUILD_INFO__: BuildInfo;
// SSR passes the same metadata emitted by Vite, so static HTML and the JS package agree.
export function BuildVersion({
  info = typeof __BUILD_INFO__ === 'undefined' ? undefined : __BUILD_INFO__,
}: {
  info?: BuildInfo;
}) {
  if (!info) return <span>开发版本</span>;
  const date = new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
    .format(new Date(info.builtAt))
    .replaceAll('/', '.');
  const label = `${info.channel === 'release' ? '版本' : '开发版本'} ${date} · ${info.sourceCommit.slice(0, 7)}${info.dirty ? '（未提交改动）' : ''}`;
  return (
    <details
      style={{
        fontSize: '12px',
        maxWidth: '100%',
        minWidth: 0,
        overflowWrap: 'anywhere',
        lineHeight: 1.7,
      }}
    >
      <summary style={{ cursor: 'pointer' }}>{label}</summary>
      <dl style={{ margin: '8px 0', maxWidth: '34rem' }}>
        <dt>应用 / 环境</dt>
        <dd style={{ margin: 0 }}>
          {info.appId} / {info.environment}
        </dd>
        <dt>完整提交号</dt>
        <dd style={{ margin: 0 }}>{info.sourceCommit}</dd>
        <dt>构建编号</dt>
        <dd style={{ margin: 0 }}>{info.buildId}</dd>
        <dt>构建时间（北京时间）</dt>
        <dd style={{ margin: 0 }}>
          {new Date(info.builtAt).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })}
        </dd>
      </dl>
    </details>
  );
}
